/**
* created by hezq on 2019-11-20
*
* description: 工具类入口
*
*/
	
import str from '@/tools/str';
import other from '@/tools/other';
import num from '@/tools/num';
import date from '@/tools/date';
import arr from '@/tools/arr';
import store from '@/tools/store';

let tools = {
	str,
	num,
	date,
	arr,
	store,
};

tools = {...tools,...other};

module.exports = tools;


// WEBPACK FOOTER //
// ./src/tools/index.js